// Shared helpers for currency, roles, permissions

export const CURRENCY = 'KWD';

export function fmtMoney(v, currency = CURRENCY) {
  const n = Number(v || 0);
  return `${currency} ${n.toLocaleString('en-US', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}`;
}

export function fmtNum(v) {
  return Number(v || 0).toLocaleString('en-US');
}

export function fmtDate(d) {
  if (!d) return '-';
  try {
    return new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return d;
  }
}

export const ROLE_LABELS = {
  owner: 'Owner',
  admin: 'Administrator',
  accountant: 'Sales',
  iron: 'Iron',
  tailor: 'Tailor',
  cutter: 'Cutter',
};

const WRITE_ROLES = ['owner', 'admin', 'accountant'];

export function canWrite(role) {
  return WRITE_ROLES.includes(role);
}

export function canDelete(role) {
  return role === 'owner' || role === 'admin';
}

export function canDeleteBill(role) {
  return role === 'owner' || role === 'admin';
}

export function homeRoute(role) {
  if (role === 'cutter') return '/my-cutting';
  if (role === 'tailor') return '/my-work';
  if (role === 'accountant') return '/sales';
  return '/dashboard';
}

// Which nav tabs each role can see
export const SIZES = ['Universal', 'Small', 'Medium', 'Large', '32', '34', '36', '38', '40', '42'];

export const ROLE_NAV = {
  owner: 'all',
  admin: 'all',
  accountant: ['inventory', 'sales'],
  cutter: ['my-cutting'],
  tailor: ['my-work'],
  iron: [],
};

export function groupLogsByDate(logs) {
  const map = {};
  for (const l of logs) {
    const d = l.date || '—';
    if (!map[d]) map[d] = { date: d, entries: 0, dozens: 0, pieces: 0, earnings: 0, products: {} };
    map[d].entries += 1;
    map[d].dozens += Number(l.quantityDozens || 0);
    map[d].pieces += Math.round(Number(l.quantityDozens || 0) * 12);
    map[d].earnings += Number(l.totalEarnings || 0);
    if (l.items?.length) {
      for (const it of l.items) map[d].products[it.productName] = (map[d].products[it.productName] || 0) + Number(it.dozens || 0);
    } else {
      map[d].products[l.productName] = (map[d].products[l.productName] || 0) + Number(l.quantityDozens || 0);
    }
  }
  return Object.values(map).sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function groupCutLogsByDate(logs) {
  const map = {};
  for (const l of logs) {
    const d = l.date || '—';
    if (!map[d]) map[d] = { date: d, entries: 0, rolls: 0, yards: 0, dozens: 0, amount: 0, products: {} };
    map[d].entries += 1;
    map[d].rolls += Number(l.rolls || 0);
    map[d].yards += Number(l.rollLengthYards || 0);
    map[d].dozens += Number(l.dozens || 0);
    map[d].amount += Number(l.earnings || 0);
    if (l.products?.length) {
      for (const p of l.products) map[d].products[p.productName] = (map[d].products[p.productName] || 0) + Number(p.dozens || 0);
    } else if (l.productName) {
      map[d].products[l.productName] = (map[d].products[l.productName] || 0) + Number(l.dozens || l.rolls || 0);
    }
  }
  return Object.values(map).sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function statusColor(status) {
  const map = {
    paid: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    partial: 'bg-amber-50 text-amber-700 border-amber-200',
    unpaid: 'bg-rose-50 text-rose-700 border-rose-200',
    refunded: 'bg-slate-100 text-slate-600 border-slate-200',
    completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    in_progress: 'bg-blue-50 text-blue-700 border-blue-200',
    pending: 'bg-amber-50 text-amber-700 border-amber-200',
  };
  return map[status] || 'bg-slate-100 text-slate-600 border-slate-200';
}
